import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { IUser } from '../../auth/models/auth.model';

export const SessionGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isAuthenticated = authService.isAuthenticated();

  // const getTenantDetail = (): ITenant | null => {
  //   return tenantService.tenantData;
  // };

  const getUserDetail = (): IUser | null => {
    return authService.getUserProfileData();
  };

  const clearUserSession = () => {
    authService.clearUserSessionData();
  };

  if (getUserDetail() && isAuthenticated) {
    const user = getUserDetail();

    if (user?.emailVerified === false) {
      return true;
    }

    if (user?.onboardingStatus === 'INCOMPLETE' || user?.onboardingStatus === 'PENDING') {
      return true;
    }

    return router.createUrlTree(['/clients/dashboard']);
  } else {
    clearUserSession();
    return true;
  }
};
